import React, { useEffect, useRef, useState } from 'react'
import { DropzoneAreaBase } from 'mui-file-dropzone'
// import { makeStyles } from '@mui/styles';
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import PropTypes from 'prop-types';
import {
    Box,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Grid,
    Typography,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    FormLabel,
    Stack
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import LoadingButton from "@mui/lab/LoadingButton";
import {
    Input,
    Select
} from "../Common"
import {
    trakrefFontFamily,
    trakrefFontFamilyBold,
    trakrefFontFamilySemiBold,
} from "../../utils";
import { Grey2, Grey3, trakrefBlue, white } from "../../color_utils";
import UserInfo from '../../UserInfo';

const ACCEPTED_FILE_TYPES = ['.text', '.jpeg', '.jpg', '.png', '.bmp', '.csv', '.docx', '.pdf', '.xlsx'];
const MAX_FILE_SIZE_BYTES = 5242880;
const MAX_FILES = 3;
const ERROR_RED = '#D51A1A';


/* const useStyles = makeStyles({
    notes: { marginTop: '4%' },
    submitButton: { backgroundColor: '#008299', color: white, fontSize: '16px', marginBottom: '30px !important', padding: '2% 0%' },
    closeButton: { position: 'absolute', right: 0, top: 0 },
    title: { textAlign: 'center', marginTop: '10px', fontSize: '22px', fontFamily: trakrefFontFamilyBold, fontWeight: "bold !Important", color: '#1B2125' },
    dropzone: { width: '66% !important', minHeight: '160px !important' },
    actionButtons: { margin: '4% 0%', justifyContent: 'center' },
    uploadIcon: { color: '#008299', fontSize: '2.9rem' },
}); */

const UserTypes = [{
    id: 22,
    name: "Super Tenant Admin",
},
{
    id: 2,
    name: "Tenant Administrator",
}, {
    id: 3,
    name: "Regional Administrator",
}, {
    id: 4,
    name: "Purchasing Administrator",
}, {
    id: 9,
    name: "Technician Manager",
}, {
    id: 6,
    name: "Technician",
}, {
    id: 8,
    name: "Read-only",
}];

const DropzoneModal = ({
    showDocumentPageField,
    dropzoneOpen,
    fileTypeId,
    refId,
    fileNotes,
    selectedFiles,
    isSaving,
    setRefId,
    setFileTypeId,
    setDropzoneFiles,
    setFileNotes,
    handleSubmit,
    handleClose,
    submitButtonText,
}) => {
    const dropzoneRef = useRef();
    const dropzoneClass = { width: '66% !important', minHeight: '160px !important' }
    const [optionDefaultValue, setOptionDefaultValue] = useState(1);
    const [uploadError, setUploadError] = useState("");
    const [options, setOptions] = useState([
        {
            value: 1,
            label: "All Users"
        },
        {
            value: 2,
            label: `All Users in ${UserInfo.instanceName}`
        },
        {
            value: 7,
            label: "All members of a group"
        },
        {
            value: 6,
            label: "All resellers"
        }
    ]);

    const ColoredUploadIcon = () => <FileUploadOutlinedIcon
        fontSize="large"
        sx={{
            color: trakrefBlue,
            marginTop: "-10px",
        }}
    />;

    const closeAndReset = () => {
        //setRefId(0);
        //setFileTypeId(0);
        setFileNotes("");
        setDropzoneFiles([]);
        setUploadError("");
        handleClose();
    }

    const handleDropRejected = (rejectedFiles) => {
        if (!rejectedFiles || rejectedFiles.length === 0) return;
        const totalAfterDrop = (selectedFiles ? selectedFiles.length : 0) + rejectedFiles.length;
        if (totalAfterDrop > MAX_FILES) {
            setUploadError(`Error: Maximum of ${MAX_FILES} files can be uploaded at once`);
            return;
        }
        const first = rejectedFiles[0];
        const fileObj = first && first.file ? first.file : first;
        const name = fileObj && fileObj.name ? fileObj.name : '';
        const size = fileObj && typeof fileObj.size === 'number' ? fileObj.size : 0;
        const dot = name.lastIndexOf('.');
        const ext = dot >= 0 ? name.slice(dot).toLowerCase() : '';
        const typeOk = ext && ACCEPTED_FILE_TYPES.includes(ext);
        if (!typeOk) {
            setUploadError(`Error: ${ext || name} is not a supported file type. Accepted types: ${ACCEPTED_FILE_TYPES.join(', ')}`);
        } else if (size > MAX_FILE_SIZE_BYTES) {
            setUploadError('Error: File exceeds the maximum size limit of 5 MB');
        } else {
            setUploadError(`Error: Maximum of ${MAX_FILES} files can be uploaded at once`);
        }
    }

    const removeFile = (index) => {
        setDropzoneFiles(null);
        const newFiles = [...selectedFiles];
        if (index > -1) {
            newFiles.splice(index, 1);
            setDropzoneFiles(newFiles);
        }
    }

    useEffect(() => {
        if (showDocumentPageField) {
            const isSystemOwnerSuperTenantAdminOrTenantAdmin = (UserInfo.isSuperTenantAdmin() || UserInfo.isTenantAdministrator()) && UserInfo.isSystemOwner() && UserInfo.isNativeUser();
            const isServiceProviderTenantAdminOrTechnicianManager = (UserInfo.isTenantAdministrator() || UserInfo.isTechnicianManager()) && UserInfo.isServiceProvider() && UserInfo.isNativeUser();

            if (isSystemOwnerSuperTenantAdminOrTenantAdmin || isServiceProviderTenantAdminOrTechnicianManager) {
                const filetype_instance = 2;
                setOptions([{
                    value: 2,
                    label: `All Users in ${UserInfo.instanceName}`
                }]);
                setOptionDefaultValue(filetype_instance);
                setFileTypeId(filetype_instance);
                setRefId(UserInfo.instanceId);
            }
            else {
                setFileTypeId(1);
            }
        }
    }, []);

    return (
        <Dialog
            open={dropzoneOpen}
            onClose={closeAndReset}
            fullWidth
            maxWidth="sm"
            aria-describedby=""
            aria-labelledby=""
        >
            <DialogTitle>
                <IconButton aria-label="close" onClick={closeAndReset} sx={{ position: 'absolute', right: 0, top: 0 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Grid container align="center">
                    <Grid item xs={12} lg={12}>
                        <Typography variant="h6" sx={{ textAlign: 'center', marginTop: '10px', fontSize: '22px', fontFamily: trakrefFontFamilyBold, fontWeight: "bold !Important", color: '#1B2125' }}>
                            Add Document
                        </Typography>
                        <Box
                            sx={{
                                position: "relative",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                flexDirection: "column",
                                gap: "10px",
                                padding: "10px",
                                marginTop: "10px"
                            }}
                        >
                            <DropzoneAreaBase
                                acceptedFiles={ACCEPTED_FILE_TYPES}
                                showPreviewsInDropzone={false}
                                showAlerts={false}
                                onAdd={(fileObjs) => {
                                    setUploadError("");
                                    setDropzoneFiles([...selectedFiles, ...fileObjs])
                                }}
                                onDropRejected={handleDropRejected}
                                getFileLimitExceedMessage={() => `Error: Maximum of ${MAX_FILES} files can be uploaded at once`}
                                onAlert={(message, variant) => {
                                    if (variant === 'error' && typeof message === 'string' && message.startsWith('Error:')) {
                                        setUploadError(message);
                                    }
                                }}
                                filesLimit={MAX_FILES}
                                maxSize={MAX_FILE_SIZE_BYTES}
                                dropzoneProps={{
                                    ref: dropzoneRef,
                                }}
                                Icon={ColoredUploadIcon}
                                dropzoneText=""
                                dropzoneClass={dropzoneClass}
                            />
                            <div
                                style={{
                                    position: "absolute",
                                    top: "65px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                    gap: "0px",
                                }}
                            >
                                <span
                                    style={{
                                        fontFamily: trakrefFontFamilySemiBold,
                                        color: Grey2,
                                        fontSize: 15,
                                        letterSpacing: "1px",
                                    }}
                                >
                                    Drag and Drop a file here
                                </span>
                                <span
                                    style={{
                                        fontFamily: trakrefFontFamilySemiBold,
                                        color: Grey2,
                                        fontSize: 13,
                                    }}
                                >
                                    or
                                </span>
                            </div>
                            <Button
                                variant="outlined"
                                size="small"
                                style={{
                                    fontSize: "14px !important",
                                }}
                                sx={{
                                    borderColor: trakrefBlue,
                                    borderWidth: "1.5px",
                                    color: trakrefBlue,
                                    fontFamily: trakrefFontFamily,
                                    letterSpacing: "1.5px",
                                    fontWeight: "600",
                                    position: "absolute",
                                    bottom: "35px",
                                    background: "transparent",
                                    ":focus": {
                                        outline: 'none'
                                    }
                                }}
                                onClick={() => dropzoneRef.current.open()}
                            >
                                BROWSE FILES
                            </Button>
                        </Box>
                        <Box sx={{ textAlign: 'center', marginTop: '4px', marginBottom: '20px', padding: '0 24px' }}>
                            <Typography
                                data-testid="dropzone-constraints-types"
                                sx={{ fontFamily: trakrefFontFamilySemiBold, color: Grey2, fontSize: 12, lineHeight: 1.5 }}
                            >
                                Accepted file types: {ACCEPTED_FILE_TYPES.join(', ')}
                            </Typography>
                            <Typography
                                data-testid="dropzone-constraints-limits"
                                sx={{ fontFamily: trakrefFontFamilySemiBold, color: Grey2, fontSize: 12, lineHeight: 1.5 }}
                            >
                                Maximum file size: 5 MB per file &middot; Maximum files per upload: {MAX_FILES}
                            </Typography>
                        </Box>
                        {uploadError && (
                            <Typography
                                role="alert"
                                aria-live="polite"
                                data-testid="dropzone-upload-error"
                                sx={{
                                    color: ERROR_RED,
                                    fontFamily: trakrefFontFamilySemiBold,
                                    fontSize: 13,
                                    textAlign: 'center',
                                    marginTop: '4px',
                                    marginBottom: '20px',
                                    padding: '0 24px',
                                }}
                            >
                                {uploadError}
                            </Typography>
                        )}
                        {selectedFiles.length > 0 && selectedFiles.map((x, index) => (
                            <div style={{
                                display: "flex",
                                width: "64%",
                                justifyContent: "space-between",
                                alignItems: "center",
                                flexDirection: "row",
                                background: "#F5F5F5",
                                padding: "8px",
                                marginBottom: "20px"
                            }}>
                                <span
                                    style={{
                                        color: trakrefBlue,
                                        fontFamily: trakrefFontFamilyBold,
                                        fontSize: "13px",
                                    }}
                                >
                                    {`${x.file.name} - ${x.file.size} bytes`}
                                </span>
                                <CloseRoundedIcon onClick={() => removeFile(index)} sx={{ fontSize: "15px !important", color: Grey3, cursor: "pointer" }} />
                            </div>
                        ))}
                        <Stack
                            direction="column"
                            justifyContent="center"
                            alignItems="flex-start"
                            spacing={2}
                            sx={{
                                marginTop: "-10px",
                                padding: "0px 100px 35px 100px",
                                gap: "5px"
                            }}>
                            {showDocumentPageField &&
                                <FormControl
                                    sx={{
                                        "& .MuiFormLabel-root": {
                                            textAlign: "start !important",
                                            fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
                                            fontSize: "12px",
                                            color: trakrefBlue,
                                            fontWeight: "bold",
                                            textTransform: "Uppercase",
                                            "&.Mui-focused": {
                                                color: trakrefBlue,
                                            },
                                        },
                                        marginTop: "50px",
                                    }}>
                                    <FormLabel id="demo-radio-buttons-group-label">Shared With</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        defaultValue={optionDefaultValue}
                                        name="radio-buttons-group"
                                        sx={{
                                            "& .MuiFormControlLabel-root": {
                                                margin: "0px",
                                                padding: "0px",
                                                fontFamily: trakrefFontFamily,
                                                fontSize: "13px",
                                                height: "30px",
                                            },
                                            "& .MuiSvgIcon-root": {
                                                fill: trakrefBlue
                                            },
                                            ":focus": {
                                                color: "red"
                                            },
                                            marginLeft: "-10px"
                                        }}
                                        onChange={(e) => {
                                            const { value } = e.target;
                                            if (value === "2") {
                                                setRefId(UserInfo.instanceId)
                                            }
                                            setFileTypeId(value);
                                        }}
                                    >
                                        {
                                            options.map(({ value, label }) => (
                                                <FormControlLabel value={value} control={<Radio />} label={label} />
                                            ))
                                        }
                                    </RadioGroup>
                                </FormControl>
                            }
                            {
                                (showDocumentPageField && fileTypeId === "7") && (
                                    <Select
                                        variant="outlined"
                                        value={refId}
                                        label="Groups"
                                        options={UserTypes}
                                        onChange={(e) => setRefId(e.target.value)}
                                    />
                                )
                            }
                            <Input label="Notes"
                                fullWidth
                                variant="outlined"
                                value={fileNotes}
                                onChange={e => setFileNotes(e.target.value)} />
                            <LoadingButton
                                fullWidth
                                size="large"
                                variant="contained"
                                loading={isSaving}
                                onClick={handleSubmit}
                                sx={{
                                    "& .MuiCircularProgress-root": {
                                        color: "#FFFFFF",
                                        width: "21px !important",
                                        height: "21px !important",
                                    },
                                    ":focus": {
                                        outline: 'none'
                                    }
                                }}
                                style={{
                                    backgroundColor: trakrefBlue,
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontFamily: trakrefFontFamilyBold,
                                        backgroundColor: trakrefBlue,
                                        letterSpacing: "1.2px",
                                        padding: "1% 0%",
                                        color: isSaving ? "transparent" : "#fff",
                                        fontSize: 17,
                                        fontWeight: 400,
                                    }}
                                >
                                    {submitButtonText}
                                </Typography>
                            </LoadingButton>
                        </Stack>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

DropzoneModal.propTypes = {
    showDocumentPageField: PropTypes.bool,
    dropzoneOpen: PropTypes.bool.isRequired,
    fileTypeId: PropTypes.number,
    refId: PropTypes.number,
    fileNotes: PropTypes.string.isRequired,
    selectedFiles: PropTypes.object,
    isSaving: PropTypes.bool,
    setRefId: PropTypes.func,
    setFileTypeId: PropTypes.func,
    setDropzoneFiles: PropTypes.func.isRequired,
    setFileNotes: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired,
    submitButtonText: PropTypes.string,
};

DropzoneModal.defaultProps = {
    showDocumentPageField: false,
    submitButtonText: 'Add Document',
};

export default DropzoneModal;
